module.exports = __webpack_public_path__ + "8bec274cf7d34006cd77cf303816cf9f.pdf";